import { useEffect } from 'react';
import { Path, UseFormReturn } from 'react-hook-form';

import { getDraft, removeDraft } from '../draftStorage';

export const useLoadFormDraft = <T>(
    form: UseFormReturn<T>,
    storageKey: string,
    excludedFields: readonly string[] = [],
): void => {
    useEffect(() => {
        if (typeof window === 'undefined') return;

        const saved = getDraft(storageKey);
        if (!saved) return;

        try {
            const draft: Partial<T> = JSON.parse(saved);
            Object.entries(draft).forEach(([key, value]) => {
                if (excludedFields.includes(key as Path<T>)) return;
                form.setValue(key as Path<T>, value as any, {
                    shouldDirty: true,
                });
            });
        } catch {
            removeDraft(storageKey);
        }
    }, []);
};
